module.exports = __webpack_public_path__ + "img/cartoon-man-confused-about-crypto-currency.d9f26af4.webp";